import React, { Component } from "react"
import PropTypes from "prop-types"
import ReactDOM from 'react-dom/client';
 import {   BrowserRouter as Router, Routes, Route, useLocation } from "react-router"

import { InstantSearch, Configure } from 'react-instantsearch';
import { liteClient as algoliasearch } from 'algoliasearch/lite';

import qs from "qs"
 import GeneralSearch from "./search-general"
import CategorySearch from "./search-category"

const credentials = ALGOLIA_CREDENTIALS || null
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);
const UPDATE_AFTER = 700 

const mapSearchStateToUrl = (props, searchState) =>
    `${props.location.pathname}?${qs.stringify(searchState)}`

const mapUrlToSearchState = (url) => {
	const urlObj = qs.parse(url)
	delete urlObj.page
	return urlObj
}

const root = document.querySelector(".js-search")
const categoryData = root ? JSON.parse(root.getAttribute("data-category")) : null

function renderComponent(Component, props = {}) {
  return <Component {...props} />;
}

function SearchContainerWrapper(props) {
	const location = useLocation();
	return (
		<SearchContainer
			{...props}
			location={location}
		/>
	);
}

function Search({ category }) {

	if(category)
	{
		return  renderComponent( CategorySearch, {attribute: 'category', category: categoryData } );
	}
	else
	{
	 return renderComponent( GeneralSearch );
	}
}

class SearchContainer extends Component {
	static propTypes = {
		history: PropTypes.shape({
			replace: PropTypes.func.isRequired,
		}).isRequired,
		location: PropTypes.shape({
			pathname: PropTypes.string,
			search: PropTypes.string,
		}).isRequired,
	};

	static defaultProps = {
		category: null,
	};

	constructor(props) {
		super(props)
		var searchState = mapUrlToSearchState(this.props.location.search.slice(1));
			if( categoryData?.applicationCategory )
			{
				if (typeof searchState.sortBy === 'undefined') {
					searchState.sortBy = 'products_alphabetical_asc';
				}
			}
		this.state = {
			searchState: searchState,
		}
		if (props.location.search.includes("refinementList")) {
			window.dataLayer.push({
				event: "search",
				parameters: mapSearchStateToUrl( props, this.state.searchState).replace(/%26/, "and"),
			})
		}
	}

	onSearchStateChange = ( searchState ) => {
		window.clearTimeout( this.debouncedSetState )

		this.debouncedSetState = setTimeout(() => {
			this.props.history.replace(
                mapSearchStateToUrl( this.props, searchState ),
                searchState,
            )
            // Push search event to dataLayer to trigger virtual page view
			window.dataLayer.push({
				event: "search",
				parameters: mapSearchStateToUrl( this.props, searchState ).replace(/%26/, "and"),
			})
		}, UPDATE_AFTER)

		this.setState({ searchState })
	}
	
	render() {
		const items =   [
		{
			value: "products_alphabetical_asc",
			label: "Alphabetically: A-Z",
		},
		{
			value: "products_newest_desc",
			label: "Newest",
		}];
		var insexName = 'products';
		var filters = 'enabled:true';
		if( categoryData?.applicationCategory )
		{
			insexName = 'products_alphabetical_asc';
			filters = `applicationCategory:"${categoryData?.applicationCategory}" AND enabled:true`;
		}
		if( categoryData?.productCategory )
		{
			filters = `productCategories:"${categoryData?.productCategory}" AND enabled:true`;
		}
		
		return (
			   <InstantSearch 
					searchClient={searchClient} 
					indexName={insexName}  
					searchState={this.state.searchState}  
					onSearchStateChange={this.onSearchStateChange}
					routing={false}

				>
				 <Configure  filters={filters}  />
                  <Search category={categoryData} />   
                </InstantSearch>
		)
	}
}

if (root && root != null && credentials) {
  const root1 = ReactDOM.createRoot( root );
	root1.render(<Router>
				  <Routes>
					<Route path="/search" element={<SearchContainerWrapper/>} />
					<Route path="/products/:category" element={<SearchContainerWrapper/>} />
					<Route path="/applications/:category" element={<SearchContainerWrapper/>} />
				</Routes>
        </Router>)
}